import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from 'material-ui/styles';
import Button from "material-ui/Button";
import Cancel from '../Icons/Cancel';

const styles = () => ({
  root: {
    height: '100vh',
    width: '320px',
    zIndex: 3,
    position: 'fixed',
    background: '#FFFFFF',
    boxShadow: '0px 3px 6px #0000001A',
  },

  navHeader: {
    padding: '25px 0 15px 40px',
    letterSpacing: '0.2px',
    textIndent: '0.2px',
    fontSize: 20,
    color: '#5F6368',
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
  },

  iconBtn: {
    minWidth: 'unset',
  },

  navTitle: {
    marginRight: '10px',
    letterSpacing: '0.2px',
    textIndent: '0.2px',
  },

  navMenu: {
    letterSpacing: '0.3px',
    textIndent: '0.3px',
    color: '#181819',
    cursor: 'pointer',
    margin: '0px',
    padding: '30px 0 0',
    '& li:first-child': {
      fontSize: 17,
      padding: '15px 40px',
    },
    '& li': {
      letterSpacing: '0.26px',
      textIndent: '0.26px',
      fontSize: 15,
      padding: '15px 70px',
      listStyle: 'none',
      cursor: 'pointer',
      '&:hover': {
        color: '#195AFF',
        background: '#E8EFFF',
      }
    },
  },
});


class FaqNavigation extends React.Component {
  constructor(props) {
    super(props);
    this.handleClick = this.handleClick.bind(this);
  }

  componentDidMount() {
    document.addEventListener('click', this.handleClick);
  }
  componentWillUnmount() {
    document.removeEventListener('click', this.handleClick);
  }

  goToPage = (link) => {
    this.props.toggleFaqNavigation();
    this.props.goTo(link);
  }

  handleClick(e) {
    // componentの外側をクリックされたら閉じる
    if (!e.target.closest('#nav')) {
      this.props.toggleFaqNavigation();
    }
  }

  render() {
    const { classes } = this.props;
    return (
      <div className={classes.root} id="nav">
        <div className={classes.navHeader}>
          <div style={{ cursor: 'pointer' }} onClick={() => this.props.goTo('/how-to')}>
            <span className={classes.navTitle}>Keyman Letter</span>
            <span className={classes.navTitle}>ヘルプ</span>
          </div>
          <Button
            color="default"
            onClick={this.props.toggleFaqNavigation}
            className={classes.iconBtn}
          >
            <Cancel width={20} height={20} color={'#5F6368'} />
          </Button>
        </div>
        <ul className={classes.navMenu}>
          <li onClick={() => this.goToPage('/how-to/send-letter')}>レター送付ガイド</li>
          <li onClick={() => this.goToPage('/how-to/send-letter/guide')}>Keyman Letter入稿ガイド</li>
          <li onClick={() => this.goToPage('/how-to/send-letter/tips')}>レター書き方Tips</li>
          <li onClick={() => this.goToPage('/how-to/send-letter/qrcode')}>QRコードの効果的な活用方法</li>
        </ul>
        <ul className={classes.navMenu}>
          <li onClick={() => this.goToPage('/how-to/salesforce')}>Salesforce連携</li>
          <li onClick={() => this.goToPage('/how-to/salesforce/connect-account')}>アカウント連携方法</li>
          <li onClick={() => this.goToPage('/how-to/salesforce/operation')}>レター送付のSalesforceの運用イメージ</li>
          <li onClick={() => this.goToPage('/how-to/salesforce/duplication')}>Salesforceとのデータの重複について</li>
        </ul>
        <ul className={classes.navMenu} style={{ paddingTop: 10 }}>
          <li onClick={() => this.goToPage('/how-to/faq')}>よくある質問</li>
        </ul>
      </div>
    )
  }
}

FaqNavigation.propTypes = {
  classes: PropTypes.object.isRequired,
  toggleFaqNavigation: PropTypes.func.isRequired,
  goTo: PropTypes.func.isRequired,
};

export default withStyles(styles)(FaqNavigation);



// WEBPACK FOOTER //
// ./src/components/Faq/FaqNavigation.jsx